import type { IMailVerifyReturn } from "@Front/Api/Auth/Customer/Auth";
import type { EmailAuthCandidatesResponse } from "@Front/Api/Public/emailAuthCandidatesApi";
import { LoginStep } from "@Front/Components/Layouts/Login/hooks/useLoginController";
import type { ValidationError } from "class-validator";

export function snapshotFromMailVerifyNeedsChoice(res: IMailVerifyReturn): EmailAuthCandidatesResponse {
	return {
		actorChoiceRequired: res.actorChoiceRequired ?? false,
		customerCandidates: res.customerCandidates ?? [],
		thirdPartyCandidates: res.thirdPartyCandidates ?? [],
		totalChoiceRows: res.totalChoiceRows ?? 0,
	};
}

export function applyCustomerLoginFlowAfterMailVerifyNeedsChoice(
	res: IMailVerifyReturn,
	params: {
		setLoginCandidates: (value: EmailAuthCandidatesResponse | null) => void;
		setStep: (step: LoginStep) => void;
		setValidationErrors: (errors: ValidationError[]) => void;
	},
): void {
	params.setLoginCandidates(snapshotFromMailVerifyNeedsChoice(res));
	params.setStep(res.actorChoiceRequired ? LoginStep.ACTOR_CHOICE : LoginStep.CUSTOMER_TARGET_CHOICE);
	params.setValidationErrors([]);
}
